/* Product page behaviour: the docket bar, and disclosures that take you to what you opened.
 *
 * No framework, no dependency, and nothing here is required for the page to work — every control it
 * touches already functions without JavaScript. */

/* ------------------------------------------------------------------ the docket bar
 *
 * The buy card is sticky within .pdp and releases at its end, deliberately, so it never floats over
 * the recommendation shelves. From there down the page had no add control at all — on a PDP with a
 * spec table, branch availability and two shelves, that is most of the page.
 *
 * The bar appears exactly when the real Add button leaves the viewport and hides the moment it comes
 * back, so the two are never on screen together saying the same thing. An IntersectionObserver
 * rather than a scroll handler: it fires on a boundary rather than on every frame of a scroll. */
const dock = document.querySelector('[data-pdp-dock]')
const realAdd = document.querySelector('.pdp__buy .pdp__add')

if (dock && realAdd) {
  const show = (on) => {
    dock.hidden = false
    dock.toggleAttribute('data-on', on)
    /* inert AND aria-hidden while parked, and its button is never a tab stop: the bar duplicates a
       control that already exists above it, and a keyboard or screen-reader shopper meeting the same
       product twice on one page is worse served than by a bar they never meet. The real buy box
       stays the accessible one throughout. */
    dock.setAttribute('aria-hidden', String(!on))
    if ('inert' in dock) dock.inert = !on
  }
  show(false)
  new IntersectionObserver(
    ([e]) => show(!e.isIntersecting),
    { rootMargin: '0px 0px -8px 0px' },
  ).observe(realAdd)

  /* The bar's button submits the real form rather than posting its own. requestSubmit(), not
     submit(): submit() dispatches no submit event, so anything delegating on one — the quick view's
     interceptor, for instance — would silently miss an add made from here. */
  dock.querySelector('[data-pdp-dock-add]')?.addEventListener('click', () => {
    const form = document.querySelector('.pdp__buy form[action*="/cart/add"]')
    if (form?.requestSubmit) form.requestSubmit()
    else form?.submit()
  })
}

/* --------------------------------------------------- disclosures that go where they say
 *
 * A disclosure near the top of a long column opens content that can land below the fold — the
 * shopper taps "Pack & size", the page does not move, and nothing appears to have happened. Opening
 * one now brings it into view.
 *
 * scrollIntoView only when the panel is actually out of view, and only on OPEN — scrolling on close
 * would yank the page toward something the shopper just dismissed. `block: 'nearest'` moves the
 * least amount that works rather than centring, so the surrounding context survives. */
for (const group of document.querySelectorAll('.specgroup')) {
  group.addEventListener('toggle', () => {
    if (!group.open) return
    const r = group.getBoundingClientRect()
    const chrome = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--chrome-h')) || 80
    if (r.top >= chrome && r.bottom <= innerHeight) return
    group.scrollIntoView({
      block: 'nearest',
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    })
  })
}

/* --------------------------------------------------- the price follows the chosen variant
 *
 * ENHANCEMENT ONLY. The radios are named `id` inside the product form, so choosing a size already
 * works with JavaScript off — Shopify reads the selection straight off the form, and the docket
 * bar's button submits that same form. All this does is stop the headline price from contradicting
 * the card the shopper just picked.
 *
 * The formatted string is rendered into `data-variant-price` by Liquid rather than formatted here:
 * money format is a shop setting with per-locale rules, and re-implementing it in the browser is how
 * two prices on one page begin to disagree.
 */
{
  const picker = document.querySelector('.vpick')
  if (picker) {
    const price = document.querySelector('.pdp__price bdi')
    const dockMeta = document.querySelector('.pdp__dock-meta bdi')
    picker.addEventListener('change', (e) => {
      const radio = e.target.closest('.vpick__radio')
      const text = radio?.dataset.variantPrice
      if (!text) return
      if (price) price.textContent = text
      if (dockMeta) dockMeta.textContent = text
      /* The per-unit line is computed from PRODUCT-level net content, so it cannot be recomputed for
         a different size. Removed rather than left showing the 462g maths under the 1.8kg price — a
         stale figure that still looks true is worse than an absent one. */
      document.querySelector('.pdp__unit')?.remove()
    })
  }
}
